/*
 * Browns – Book an Appointment drawer.
 * Config: #baa-config · Stores: #baa-stores (snippets/book-appointment-drawer.liquid)
 *
 * Zoho IDs (store, contact) are kept as STRINGS end to end. Never Number()/parseInt them:
 * 19-digit IDs exceed Number.MAX_SAFE_INTEGER and get rounded.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('baa-config');
  var storesEl = document.getElementById('baa-stores');
  var root = document.getElementById('baa-root');
  if (!cfgEl || !storesEl || !root) return;

  var cfg = JSON.parse(cfgEl.textContent);
  // Stores flagged "test": true (e.g. the TDMC Test store) only show with ?baa_test=1 in the URL.
  var testMode = /[?&]baa_test=1\b/.test(window.location.search);
  var stores = JSON.parse(storesEl.textContent).filter(function (s) { return !s.test || testMode; });
  var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var SHORT_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  var params = new URLSearchParams(window.location.search);
  // Contact ID from CRM email links (?cid= / ?client_id=), kept as a string.
  var cidMatch = window.location.search.match(/(?:cid|client_id)=([0-9]+)/i);
  var contactId = cidMatch ? cidMatch[1] : '';

  var state;
  var lastTrigger = null;
  var dryRun = Object.keys(cfg.webform).some(function (k) { return String(cfg.webform[k]).indexOf('TODO') === 0; });

  function resetState() {
    state = {
      step: 'store',
      source: cfg.defaultSource,
      store: null,
      lockedStore: false,
      country: countryKnown(cfg.defaultCountry) ? cfg.defaultCountry : 'ZA',
      region: 'all',
      type: null,
      date: null,
      time: '',
      calOpen: false,
      occCalOpen: false,
      occViewYear: null,
      occViewMonth: null,
      slotError: '',
      viewYear: null,
      viewMonth: null,
      productTitle: '',
      productUrl: '',
      contact: { firstName: '', lastName: '', area: '', mobile: '', email: '' },
      extra: { occasion: '', occasionDate: '', budget: '', notes: '' },
      touched: {},
      submitting: false,
      error: ''
    };
  }

  function countryKnown(c) { return stores.some(function (s) { return s.country === c; }); }
  // Accepts a short code (RSE), Zoho store ID, store name ("Rosebank Mall"), or location
  // page URL/handle ("/pages/location/rosebank-mall", incl. "copy-of-" handles).
  function slug(v) {
    return String(v).toLowerCase().replace(/^.*\/pages\/location\//, '').replace(/^copy-of-/, '')
      .replace(/&/g, ' ').replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function findStore(ref) {
    if (!ref) return null;
    var raw = String(ref).trim(), code = raw.toUpperCase(), key = slug(raw);
    return stores.filter(function (s) { return s.code === code || s.zohoId === raw; })[0] ||
      stores.filter(function (s) { return slug(s.name) === key || (s.url && slug(s.url) === key); })[0] || null;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  function startOfDay(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
  function sameDay(a, b) { return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }
  function toMin(hhmm) { var p = hhmm.split(':'); return parseInt(p[0], 10) * 60 + parseInt(p[1], 10); }
  function fmtTime(min) {
    var h = Math.floor(min / 60), m = min % 60, ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + '.' + pad(m) + ' ' + ap;
  }
  // Zoho webform date format ("MMM D, YYYY"): "Oct 3, 2026"
  function zohoDate(d) { return SHORT_MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear(); }
  // Webform datetime fields take 12h hour + minute + AM/PM selects
  function hour12(d) { var h = d.getHours() % 12; return pad(h === 0 ? 12 : h); }
  function ampm(d) { return d.getHours() >= 12 ? 'PM' : 'AM'; }
  function displayDate(d) { return SHORT_DAYS[d.getDay()] + ' ' + SHORT_MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear(); }

  function hoursFor(store, date) {
    if (!store.hours) return cfg.defaultHours;
    var h = store.hours[DAYS[date.getDay()]];
    return h === undefined ? cfg.defaultHours : h;
  }
  function typeDef(id) { return cfg.appointmentTypes.filter(function (t) { return t.id === id; })[0]; }
  // Appointment length per type (Care Services 20 min, Personalised Shopping 45 min).
  function durationFor(typeId) {
    var t = typeDef(typeId);
    if (t && t.durationMinutes) return t.durationMinutes;
    // No type chosen yet: use the shortest so a day only shows as closed if nothing fits.
    return Math.min.apply(null, cfg.appointmentTypes.map(function (x) { return x.durationMinutes || cfg.durationMinutes; }));
  }
  // Slot interval per type: Personalised Shopping on the hour (60), Care Services every 30 min.
  function intervalFor(typeId) {
    var t = typeDef(typeId);
    if (t && t.slotMinutes) return t.slotMinutes;
    return Math.min.apply(null, cfg.appointmentTypes.map(function (x) { return x.slotMinutes || cfg.slotMinutes; }));
  }
  // Slots start on the type's interval and must finish by closing time.
  function slotsFor(store, date, typeId) {
    var h = hoursFor(store, date);
    if (!h) return [];
    var out = [], dur = durationFor(typeId), step = intervalFor(typeId), close = toMin(h[1]);
    for (var m = Math.ceil(toMin(h[0]) / step) * step; m + dur <= close; m += step) out.push(m);
    return out;
  }

  /* ── Availability: one booking per time per store ─────────
     cfg.availability.url = the Zoho function "get_booked_slots" REST API URL (API key).
     Returns booked [start,end] ranges for a store + date; a slot that overlaps one is taken.
     If the URL isn't set or the call fails, nothing is blocked (all slots stay open). */
  var busyCache = {};
  function isoDate(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function busyKey(store, date) { return store.zohoId + '|' + isoDate(date); }
  function availabilityOn() { var a = cfg.availability; return !!(a && a.url && a.url.indexOf('TODO') !== 0); }
  function fetchBusy(store, date, force) {
    var key = busyKey(store, date);
    if (!availabilityOn()) return Promise.resolve(null);
    if (!force && busyCache[key] && busyCache[key].status !== 'error') return busyCache[key].promise;
    var entry = busyCache[key] = { status: 'loading', ranges: [] };
    var url = cfg.availability.url + (cfg.availability.url.indexOf('?') > -1 ? '&' : '?') +
      'store_id=' + encodeURIComponent(envStoreId(store.zohoId)) + '&date=' + encodeURIComponent(isoDate(date));
    var timer;
    entry.promise = Promise.race([
      fetch(url, { cache: 'no-store' }).then(function (r) { return r.json(); }),
      new Promise(function (_, reject) { timer = setTimeout(function () { reject(new Error('timeout')); }, cfg.availability.timeoutMs || 6000); })
    ]).then(function (res) {
      clearTimeout(timer);
      // Zoho function REST response: { details: { output: "<json string>" } }
      var out = res && res.details && res.details.output;
      var data = typeof out === 'string' ? JSON.parse(out) : (out || res);
      entry.ranges = (data.booked || []).map(function (b) { return [toMin(b.start), toMin(b.end)]; });
      entry.status = 'ok';
      return entry;
    }).catch(function (err) {
      clearTimeout(timer);
      entry.status = 'error'; entry.ranges = [];
      if (window.console) console.warn('[Book an Appointment] availability check failed – all slots left open', err);
      return entry;
    });
    return entry.promise;
  }
  function busyFor(store, date) { return (store && date && busyCache[busyKey(store, date)]) || null; }
  function slotTaken(store, date, typeId, m) {
    var b = busyFor(store, date);
    if (!b || b.status !== 'ok') return false;
    var end = m + durationFor(typeId);
    return b.ranges.some(function (r) { return m < r[1] && end > r[0]; });
  }
  function freeSlotValues(store, date, typeId) {
    return slotsFor(store, date, typeId).filter(function (m) { return !slotTaken(store, date, typeId, m); })
      .map(function (m) { return pad(Math.floor(m / 60)) + ':' + pad(m % 60); });
  }
  // Load the day's bookings, then re-render if the customer is still on that date.
  function loadBusy(force) {
    var s = state.store, d = state.date;
    if (!s || !d || !availabilityOn()) return;
    fetchBusy(s, d, force).then(function () {
      if (state.store !== s || !sameDay(state.date, d)) return;
      if (state.time && freeSlotValues(s, d, state.type).indexOf(state.time) < 0) state.time = '';
      if (state.step === 'details') render('[data-baa-time]');
    });
    if (state.step === 'details') render('[data-baa-time]');
  }
  function slotValues(store, date, typeId) {
    return slotsFor(store, date, typeId).map(function (m) { return pad(Math.floor(m / 60)) + ':' + pad(m % 60); });
  }
  function dateSelectable(store, d) {
    var today = startOfDay(new Date());
    var max = new Date(today); max.setDate(max.getDate() + cfg.maxDaysAhead);
    return d > today && d <= max && slotsFor(store, d, state.type).length > 0;
  }

  /* ── Validation ───────────────────────────────────────── */
  var validators = {
    firstName: function (v) { return v.trim().length > 0 || 'Please enter your first name'; },
    lastName: function (v) { return v.trim().length > 0 || 'Please enter your last name'; },
    area: function (v) { return /^\+?\d{1,4}$/.test(v.trim()) || 'Invalid code'; },
    mobile: function (v) { var d = v.replace(/\D/g, '').replace(/^0/, ''); return (d.length >= 8 && d.length <= 11) || 'Please enter a valid mobile number'; },
    email: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()) || 'Please enter a valid email address'; }
  };
  function fieldError(k) { var r = validators[k](state.contact[k]); return r === true ? '' : r; }
  // Optional DD/MM/YYYY – only validated when filled in.
  function occasionDateError() {
    var v = state.extra.occasionDate.trim();
    if (!v) return '';
    var m = v.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!m) return 'Please use DD/MM/YYYY';
    var d = new Date(+m[3], +m[2] - 1, +m[1]);
    return (d.getDate() === +m[1] && d.getMonth() === +m[2] - 1) ? '' : 'Please enter a valid date';
  }
  function contactValid() { return Object.keys(validators).every(function (k) { return !fieldError(k); }) && !occasionDateError(); }
  function detailsValid() { return !!(state.store && state.type && state.date && state.time); }

  /* ── Render ───────────────────────────────────────────── */
  function shell(body, footer) {
    return '' +
      '<div class="baa-overlay" data-baa-close></div>' +
      '<div class="baa-drawer" role="dialog" aria-modal="true" aria-labelledby="baa-title">' +
        '<div class="baa-head">' +
          '<h2 class="baa-title" id="baa-title">Book an Appointment</h2>' +
          '<button type="button" class="baa-close" data-baa-close aria-label="Close">' +
            '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="baa-body" data-baa-body>' + body + '</div>' +
        (footer ? '<div class="baa-foot">' + footer + '</div>' : '') +
      '</div>';
  }

  function addressLines(s) {
    var a = s.address.slice();
    var last = a.pop();
    return '<p class="baa-addr">' + esc(a.join(', ')) + (a.length ? '<br>' : '') + esc(last) + '</p>';
  }

  // A store can sit in more than one region (e.g. Flagship Boutiques + its province).
  function storeRegions(s) { return s.regions || (s.region ? [s.region] : []); }

  function renderStoreStep() {
    var inCountry = stores.filter(function (s) { return s.country === state.country; });
    var countries = Object.keys(cfg.countries).filter(countryKnown);
    var showFilter = stores.length > cfg.filterThreshold;
    var regions = Object.keys(cfg.regions).filter(function (r) { return inCountry.some(function (s) { return storeRegions(s).indexOf(r) > -1; }); });
    var list = inCountry.filter(function (s) { return state.region === 'all' || storeRegions(s).indexOf(state.region) > -1; });

    var filter = '';
    if (showFilter) {
      filter = '<div class="baa-filter">';
      if (countries.length > 1) {
        filter += '<label class="baa-select"><span class="baa-sr">Country</span><select data-baa-country>' +
          countries.map(function (c) { return '<option value="' + c + '"' + (c === state.country ? ' selected' : '') + '>' + esc(cfg.countries[c]) + '</option>'; }).join('') +
          '</select></label>';
      }
      if (regions.length > 1) {
        filter += '<label class="baa-select"><span class="baa-sr">Region</span><select data-baa-region>' +
          '<option value="all">All</option>' +
          regions.map(function (r) { return '<option value="' + r + '"' + (r === state.region ? ' selected' : '') + '>' + esc(cfg.regions[r]) + '</option>'; }).join('') +
          '</select></label>';
      }
      filter += '</div>';
    }

    var rows = list.map(function (s) {
      return '<li class="baa-store">' +
        '<div><p class="baa-store__name">' + esc(s.name) + '</p>' + addressLines(s) + '</div>' +
        '<button type="button" class="baa-link" data-baa-select="' + esc(s.code) + '" aria-label="Select ' + esc(s.name) + '">Select</button>' +
      '</li>';
    }).join('');

    return shell(filter + '<ul class="baa-stores">' + rows + '</ul>', '');
  }

  // Appointment-type icons from the design (svg/icon_shopping_*, svg/icon_services_*).
  // Default and selected only differ in colour, so one currentColor SVG each; CSS sets the colour.
  var TYPE_ICONS = {
    store: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 69.73 50.723\" fill=\"currentColor\" aria-hidden=\"true\" focusable=\"false\"><g transform=\"translate(0 0)\"><path d=\"M68.975,16.735a.756.756,0,0,0,.755-.755V.753A.755.755,0,0,0,68.975,0H.755A.755.755,0,0,0,0,.753V15.981a.756.756,0,0,0,.755.755H6.142V49.214H4.6a.755.755,0,0,0,0,1.51H65.136a.755.755,0,0,0,0-1.51H63.589V16.735ZM20.412,49.214H7.422V16.734H20.412Zm27.619,0H21.7V16.734H48.031Zm14.314,0H49.254V16.734H62.345ZM1.1,15.534,1.187,1.216l67.46.032L68.56,15.566Z\" transform=\"translate(0 -0.001)\"/><path d=\"M28.208,19.613a6.418,6.418,0,0,0-3.568,1.077,9.992,9.992,0,0,1-2.608,4.662c0,.019-.006.034-.006.052a6.185,6.185,0,0,0,.74.04,6.056,6.056,0,0,0,6.184-5.786,6.185,6.185,0,0,0-.742-.045\" transform=\"translate(13.65 12.155)\"/><path d=\"M18.024,19.613a6.418,6.418,0,0,1,3.568,1.077A9.967,9.967,0,0,0,24.2,25.352l0,.052a6.158,6.158,0,0,1-.739.04,6.055,6.055,0,0,1-6.186-5.786,6.2,6.2,0,0,1,.745-.045\" transform=\"translate(10.709 12.155)\"/><path d=\"M22.9,17.185a2.919,2.919,0,0,0-2.857,2.98,9.6,9.6,0,0,0,2.857,6.7,9.622,9.622,0,0,0,2.849-6.7,2.915,2.915,0,0,0-2.849-2.98\" transform=\"translate(12.421 10.65)\"/><path d=\"M6.266,8.469a1.649,1.649,0,0,1-.169.984,1.287,1.287,0,0,1-.871.27v.282h2.45a5.927,5.927,0,0,0,1.245-.121,3.129,3.129,0,0,0,1.01-.391,2.463,2.463,0,0,0,.805-.794,2.256,2.256,0,0,0,.3-1.146,1.976,1.976,0,0,0-.606-1.482,2.632,2.632,0,0,0-1.412-.66V5.384a2.47,2.47,0,0,0,.66-.3,1.905,1.905,0,0,0,.614-.6,1.768,1.768,0,0,0,.271-.971,1.854,1.854,0,0,0-.161-.78,1.546,1.546,0,0,0-.467-.594,1.9,1.9,0,0,0-.708-.322,4.286,4.286,0,0,0-1.062-.108H5.291V2a1.15,1.15,0,0,1,.821.27,1.658,1.658,0,0,1,.155.956ZM7.219,2.5a.573.573,0,0,1,.032-.242.22.22,0,0,1,.1-.094.519.519,0,0,1,.205-.054,2.141,2.141,0,0,1,.32-.026,1.579,1.579,0,0,1,1.3.511,1.721,1.721,0,0,1,.332,1.1,1.6,1.6,0,0,1-.445,1.221,1.976,1.976,0,0,1-1.364.4h-.48Zm0,3.182h.463a2.459,2.459,0,0,1,1.59.485,1.83,1.83,0,0,1,.626,1.5,1.96,1.96,0,0,1-.55,1.509,1.833,1.833,0,0,1-1.295.445.711.711,0,0,1-.672-.244,1.45,1.45,0,0,1-.163-.863Z\" transform=\"translate(10.083 2.512)\"/><path d=\"M34.162,1.712V2a1.645,1.645,0,0,1,.83.2.7.7,0,0,1,.317.538c.028.175.041.438.067.771s.041.777.041,1.3V8.065h-.028L31.251,1.712H27.493V2c.443.028.7.122.793.257a1.078,1.078,0,0,1,.026.78c-.08.4-.178.917-.311,1.511s-.282,1.213-.442,1.833-.3,1.171-.433,1.644H27.1c-.324-1.051-.648-2.089-.959-3.114S25.5,2.849,25.187,1.84h-.31c-.284,1-.577,2.006-.866,3.046-.294,1.022-.589,2.075-.885,3.141H23.1c-.232-.878-.448-1.741-.673-2.59s-.433-1.707-.637-2.562c-.094-.31-.094-.526,0-.64A1.247,1.247,0,0,1,22.56,2V1.712H19.766V2a1.143,1.143,0,0,1,.707.245,1.838,1.838,0,0,1,.378.867c.323,1.2.632,2.378.927,3.537s.593,2.318.875,3.465h.337c.256-1,.54-2.023.836-3.06s.608-2.115.943-3.278H24.8c.337,1.118.674,2.2,1,3.25s.634,2.088.917,3.087h.324q.688-2.7,1.171-4.5c.324-1.212.539-1.985.647-2.346a2.646,2.646,0,0,1,.419-.991A.662.662,0,0,1,29.782,2a.942.942,0,0,1,.969.915,6.8,6.8,0,0,1,.028.858V6.893c0,.527-.014.943-.028,1.28s-.041.608-.067.783A.749.749,0,0,1,30.4,9.5a1.165,1.165,0,0,1-.688.226v.283h2.775V9.723a1.623,1.623,0,0,1-.821-.229.714.714,0,0,1-.31-.538,7.841,7.841,0,0,1-.068-.783c-.026-.337-.032-.754-.04-1.28V3.442h.04l4.2,6.656H35.9V4.816c0-.538,0-.969.03-1.307A6.825,6.825,0,0,1,36,2.741a.741.741,0,0,1,.269-.542,1.235,1.235,0,0,1,.684-.2V1.712Z\" transform=\"translate(12.989 2.511)\"/><path d=\"M33.956,7.876c.059.377.121.732.162,1.077a7.967,7.967,0,0,0,.162.823c.107.041.22.095.35.134a2.848,2.848,0,0,0,.4.136,3.071,3.071,0,0,0,.457.094,3.628,3.628,0,0,0,.557.041,2.586,2.586,0,0,0,1.83-.674A2.3,2.3,0,0,0,38.6,7.78a2.3,2.3,0,0,0-.342-1.245,3.119,3.119,0,0,0-.8-.815,10.071,10.071,0,0,0-.863-.526,4.12,4.12,0,0,1-1.01-.758,1.573,1.573,0,0,1-.4-1.049,1.631,1.631,0,0,1,.308-.984,1.164,1.164,0,0,1,.931-.418,1.207,1.207,0,0,1,1.064.526,3.342,3.342,0,0,1,.472,1.077l.323-.067c-.043-.35-.086-.66-.124-.917s-.065-.524-.091-.767q-.243-.081-.566-.162a3.541,3.541,0,0,0-.822-.094,2.469,2.469,0,0,0-1.765.659,2.16,2.16,0,0,0-.634,1.563,1.928,1.928,0,0,0,.35,1.127,3.034,3.034,0,0,0,.781.775,9.353,9.353,0,0,0,.81.512,3.757,3.757,0,0,1,1.037.809,1.77,1.77,0,0,1,.415,1.158A1.719,1.719,0,0,1,37.3,9.345a1.328,1.328,0,0,1-1.028.445,1.581,1.581,0,0,1-1.044-.377,2.506,2.506,0,0,1-.634-.81,4.254,4.254,0,0,1-.314-.8Z\" transform=\"translate(15.825 2.485)\"/><path d=\"M18.284,1.583a2.75,2.75,0,0,0-1.845.659,3.866,3.866,0,0,0-1.1,1.631,6.194,6.194,0,0,0-.353,2.1,5.491,5.491,0,0,0,.4,2.156,3.539,3.539,0,0,0,1.105,1.5,2.6,2.6,0,0,0,1.633.553,2.82,2.82,0,0,0,2.306-1.187,5.346,5.346,0,0,0,.925-3.225,5.509,5.509,0,0,0-.428-2.193,3.629,3.629,0,0,0-1.105-1.467A2.545,2.545,0,0,0,18.3,1.583Zm-.265.4a1.762,1.762,0,0,1,1.656,1.092,7.2,7.2,0,0,1,.54,3.153A5.74,5.74,0,0,1,19.731,8.9a1.5,1.5,0,0,1-1.381.891,1.854,1.854,0,0,1-1.665-1.172,6.979,6.979,0,0,1-.541-3.006,5.91,5.91,0,0,1,.492-2.7,1.507,1.507,0,0,1,1.37-.93Z\" transform=\"translate(12.034 2.485)\"/><path d=\"M11.945,2.5a.98.98,0,0,1,.025-.253.125.125,0,0,1,.068-.083.6.6,0,0,1,.2-.054,2.5,2.5,0,0,1,.371-.028,1.737,1.737,0,0,1,1.179.445,1.877,1.877,0,0,1,.538,1.441,2.546,2.546,0,0,1-.148.918,1.679,1.679,0,0,1-.5.7,1.2,1.2,0,0,1-.488.244,2.229,2.229,0,0,1-.564.08l-.685,0Zm-.974,6a1.555,1.555,0,0,1-.163.957,1.281,1.281,0,0,1-.878.27v.282h3.038V9.724a1.229,1.229,0,0,1-.861-.27,1.6,1.6,0,0,1-.161-.957V6.273l.51.013a.8.8,0,0,1,.482.122.956.956,0,0,1,.283.364c.164.35.35.714.557,1.118s.412.755.6,1.051a2.617,2.617,0,0,0,.768.835,1.856,1.856,0,0,0,1.131.365,2.154,2.154,0,0,0,.7-.078c.016-.03.058-.16.058-.16a1.425,1.425,0,0,1-.809-.275c-.122-.095-.325-.283-.475-.42a3.176,3.176,0,0,1-.454-.618c-.245-.4-.6-1.28-.785-1.644a4.213,4.213,0,0,0-.643-.957,2.672,2.672,0,0,0,1.106-.863,2.245,2.245,0,0,0,.406-1.349,2.208,2.208,0,0,0-.208-.971,1.632,1.632,0,0,0-.551-.654,2.089,2.089,0,0,0-.8-.342,4.865,4.865,0,0,0-1.1-.095H9.984V2a1.18,1.18,0,0,1,.828.269,1.581,1.581,0,0,1,.158.955Z\" transform=\"translate(11.023 2.512)\"/></g></svg>",
    care: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 47 43.339\" fill=\"currentColor\" aria-hidden=\"true\" focusable=\"false\"><g transform=\"translate(-14 -76.23)\"><path d=\"M3.916,28.64c-1.849-4.675-2.01-9.118.266-13.677-.732-.2-1.378-.374-2.019-.554a12.755,12.755,0,0,1-1.726-.525c-.209-.092-.3-.466-.437-.709.241-.128.5-.391.722-.358.937.142,1.866.358,2.792.571a11.748,11.748,0,0,1,1.86.508,2.56,2.56,0,0,0,2.464-.322,14.43,14.43,0,0,1,7.812-2.016c1.688,0,3.378.033,5.066-.01,2.811-.071,5.622-.194,8.432-.291.217-.008.433-.011.65,0,.9.04,1.347.4,1.257,1.249-.262,2.527-1.186,4.2-4.031,4.491-1.977.2-3.97.274-5.955.423a2.368,2.368,0,0,0-1.261.452,3.723,3.723,0,0,0,.8.487,29.279,29.279,0,0,0,5.886,1.5,8.335,8.335,0,0,0,4.974-1.035,31.86,31.86,0,0,0,6.647-5.139c.18-.172.324-.383.546-.648a2.042,2.042,0,0,0-1.882-.222,7.16,7.16,0,0,0-3.73,1.958,2.232,2.232,0,0,1-1.759.676c-.18-.006-.354-.167-.651-.316a17.86,17.86,0,0,1,4.675-3.349c1.219-.471,2.694-1.04,4.056.123.3.253,1.084.082,1.579-.086a10.653,10.653,0,0,1,4.213-.554,1.756,1.756,0,0,1,1.443.722c.533.747.567,1.142-.113,1.8-1.029.989-2.087,1.947-3.156,2.891-3.11,2.748-6.194,5.526-9.366,8.2-1.337,1.129-2.567,2.5-4.382,2.914a9.715,9.715,0,0,1-2.928.4c-6.135-.548-12.182.211-18.248.952a58.468,58.468,0,0,0-6.331,1.3A5.575,5.575,0,0,1,.667,30.6c-.2-.006-.563-.251-.561-.381a.9.9,0,0,1,.358-.709,6.99,6.99,0,0,1,1.37-.362c.663-.161,1.326-.322,2.083-.5M29.635,12.5c-.82.054-1.542.125-2.267.142-3.853.094-7.708.169-11.561.262a15.637,15.637,0,0,0-6.788,1.452,6.247,6.247,0,0,1-2.638.964c-.868.021-1.243.533-1.558,1.3A16.649,16.649,0,0,0,3.911,23.1a10.724,10.724,0,0,0,1.054,4.232,1.2,1.2,0,0,0,1.431.8c2.267-.328,4.535-.673,6.813-.9,2.583-.264,5.175-.513,7.768-.582,2.025-.054,4.058.182,6.089.278a5.787,5.787,0,0,0,4.257-1.556c2.14-1.887,4.346-3.7,6.5-5.57,2.384-2.073,4.742-4.175,7.1-6.277a4.413,4.413,0,0,0,.55-.8c-.385-.126-.669-.318-.927-.287-2.027.236-3.991.573-5.562,2.127A31.027,31.027,0,0,1,31.99,19.9a8.9,8.9,0,0,1-6.484,1.163c-2.343-.577-4.641-1.345-6.953-2.048a2.751,2.751,0,0,1-1.037-.5.916.916,0,0,1-.067-.753c.912-.383,1.452-1.395,2.527-1.483,1.249-.1,2.5-.23,3.75-.312.948-.063,1.908-.019,2.853-.115,2.175-.22,2.857-.973,3.056-3.347\" transform=\"translate(14 88.971)\"/><g transform=\"translate(-306.258 236.123)\"><path d=\"M17.405,15.413a7.735,7.735,0,0,0-4.3,1.3A12.043,12.043,0,0,1,9.961,22.33c0,.023-.008.041-.008.062a7.456,7.456,0,0,0,.892.049A7.3,7.3,0,0,0,18.3,15.468a7.455,7.455,0,0,0-.894-.055\" transform=\"translate(334.265 -170.566)\"/><path d=\"M6.105,15.413a7.735,7.735,0,0,1,4.3,1.3,12.013,12.013,0,0,0,3.145,5.619l0,.062a7.423,7.423,0,0,1-.89.049,7.3,7.3,0,0,1-7.456-6.974,7.471,7.471,0,0,1,.9-.055\" transform=\"translate(329.745 -170.566)\"/><path d=\"M11.413,12.985a3.519,3.519,0,0,0-3.444,3.592,11.574,11.574,0,0,0,3.444,8.073,11.589,11.589,0,0,0,3.434-8.073,3.513,3.513,0,0,0-3.434-3.592\" transform=\"translate(332.376 -172.878)\"/></g></g></svg>"
  };
  function typeIcon(kind) {
    return '<span class="baa-tile__icon baa-tile__icon--' + kind + '">' + (TYPE_ICONS[kind] || '') + '</span>';
  }

  function renderCalendar() {
    var s = state.store;
    var html = '<div class="baa-cal" data-baa-cal>' +
      '<div class="baa-cal__head">' +
        '<button type="button" class="baa-cal__nav" data-baa-cal-nav="-1" aria-label="Previous month"' + (canGoPrev() ? '' : ' disabled') + '>‹</button>' +
        '<span class="baa-cal__month" aria-live="polite">' + MONTHS[state.viewMonth] + ' ' + state.viewYear + '</span>' +
        '<button type="button" class="baa-cal__nav" data-baa-cal-nav="1" aria-label="Next month"' + (canGoNext() ? '' : ' disabled') + '>›</button>' +
      '</div><div class="baa-cal__grid" role="grid">';
    ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].forEach(function (d) { html += '<span class="baa-cal__dow">' + d + '</span>'; });
    var first = new Date(state.viewYear, state.viewMonth, 1);
    var dim = new Date(state.viewYear, state.viewMonth + 1, 0).getDate();
    for (var i = 0; i < first.getDay(); i++) html += '<span></span>';
    for (var day = 1; day <= dim; day++) {
      var d = new Date(state.viewYear, state.viewMonth, day);
      var ok = dateSelectable(s, d);
      html += '<button type="button" class="baa-cal__day' + (sameDay(d, state.date) ? ' is-selected' : '') + '"' +
        (ok ? ' data-baa-day="' + d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + day + '"' : ' disabled') +
        ' aria-label="' + esc(displayDate(d)) + '">' + day + '</button>';
    }
    return html + '</div></div>';
  }
  // Calendar for "Is there a special date for your occasion?" – any date from today, up to 3 years ahead.
  function renderOccasionCalendar() {
    var today = startOfDay(new Date());
    var max = new Date(today); max.setFullYear(max.getFullYear() + 3);
    var y = state.occViewYear, mo = state.occViewMonth, sel = parseDmy(state.extra.occasionDate);
    var canPrev = y > today.getFullYear() || (y === today.getFullYear() && mo > today.getMonth());
    var canNext = y < max.getFullYear() || (y === max.getFullYear() && mo < max.getMonth());
    var html = '<div class="baa-cal" data-baa-occ-cal>' +
      '<div class="baa-cal__head">' +
        '<button type="button" class="baa-cal__nav" data-baa-occ-nav="-1" aria-label="Previous month"' + (canPrev ? '' : ' disabled') + '>‹</button>' +
        '<span class="baa-cal__month" aria-live="polite">' + MONTHS[mo] + ' ' + y + '</span>' +
        '<button type="button" class="baa-cal__nav" data-baa-occ-nav="1" aria-label="Next month"' + (canNext ? '' : ' disabled') + '>›</button>' +
      '</div><div class="baa-cal__grid" role="grid">';
    ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].forEach(function (d) { html += '<span class="baa-cal__dow">' + d + '</span>'; });
    var first = new Date(y, mo, 1), dim = new Date(y, mo + 1, 0).getDate();
    for (var i = 0; i < first.getDay(); i++) html += '<span></span>';
    for (var day = 1; day <= dim; day++) {
      var d = new Date(y, mo, day), ok = d >= today && d <= max;
      html += '<button type="button" class="baa-cal__day' + (sameDay(d, sel) ? ' is-selected' : '') + '"' +
        (ok ? ' data-baa-occ-day="' + y + '-' + (mo + 1) + '-' + day + '"' : ' disabled') +
        ' aria-label="' + esc(displayDate(d)) + '">' + day + '</button>';
    }
    return html + '</div></div>';
  }
  function parseDmy(v) {
    var m = String(v || '').match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    return m ? new Date(+m[3], +m[2] - 1, +m[1]) : null;
  }
  function canGoPrev() { var t = new Date(); return state.viewYear > t.getFullYear() || (state.viewYear === t.getFullYear() && state.viewMonth > t.getMonth()); }
  function canGoNext() {
    var max = startOfDay(new Date()); max.setDate(max.getDate() + cfg.maxDaysAhead);
    return state.viewYear < max.getFullYear() || (state.viewYear === max.getFullYear() && state.viewMonth < max.getMonth());
  }

  function renderDetailsStep() {
    var s = state.store;
    var types = cfg.appointmentTypes.map(function (t) {
      var on = state.type === t.id;
      return '<button type="button" class="baa-tile' + (on ? ' is-selected' : '') + '" data-baa-type="' + esc(t.id) + '" aria-pressed="' + on + '">' +
        '<span class="baa-tile__label">' + esc(t.label) + '</span>' + typeIcon(t.icon) + '</button>';
    }).join('');

    var slots = state.date && state.type ? slotsFor(s, state.date, state.type) : [];
    var busy = busyFor(s, state.date), checking = !!(busy && busy.status === 'loading');
    var timeOpts = '<option value="">' + (checking ? 'Checking availability…' : 'Time slot') + '</option>' + slots.map(function (m) {
      var v = pad(Math.floor(m / 60)) + ':' + pad(m % 60), taken = slotTaken(s, state.date, state.type, m);
      return '<option value="' + v + '"' + (v === state.time && !taken ? ' selected' : '') + (taken ? ' disabled' : '') + '>' + fmtTime(m) + (taken ? ' – booked' : '') + '</option>';
    }).join('');

    var body = '' +
      '<div class="baa-selected">' +
        '<div><p class="baa-store__name">' + esc(s.name) + '</p>' + addressLines(s) + '</div>' +
        '<button type="button" class="baa-link" data-baa-change>Change</button>' +
      '</div>' +
      '<fieldset class="baa-group"><legend class="baa-label">Select your appointment type</legend><div class="baa-tiles">' + types + '</div></fieldset>' +
      '<div class="baa-group"><p class="baa-label" id="baa-date-label">Select your preferred date</p>' +
        '<button type="button" class="baa-input baa-input--date' + (state.date ? ' has-value' : '') + '" data-baa-date-toggle aria-expanded="' + state.calOpen + '" aria-labelledby="baa-date-label">' +
          '<span>' + (state.date ? esc(displayDate(state.date)) : 'DD/MM/YYYY') + '</span>' +
          '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><rect x="1.5" y="2.5" width="13" height="12" fill="none" stroke="currentColor"/><path d="M1.5 6h13M5 1v3M11 1v3" stroke="currentColor"/></svg>' +
        '</button>' +
        (state.calOpen ? renderCalendar() : '') +
      '</div>' +
      '<div class="baa-group"><label class="baa-label" for="baa-time">Select your preferred time</label>' +
        '<div class="baa-select baa-select--full"><select id="baa-time" data-baa-time' + (state.date && state.type && !checking ? '' : ' disabled') + '>' + timeOpts + '</select></div>' +
      '</div>';

    if (state.slotError) body += '<p class="baa-err baa-err--form" role="alert">' + esc(state.slotError) + '</p>';
    var footer = '<button type="button" class="baa-back" data-baa-back>Back</button>' +
      '<button type="button" class="baa-primary" data-baa-next' + (detailsValid() ? '' : ' disabled') + '>Enter contact details</button>';
    return shell(body, footer);
  }

  function floatField(key, label, type, extra) {
    var v = state.contact[key];
    var err = state.touched[key] ? fieldError(key) : '';
    return '<div class="baa-field' + (err ? ' has-error' : '') + (extra && extra.cls ? ' ' + extra.cls : '') + '">' +
      '<input id="baa-' + key + '" name="' + key + '" type="' + type + '" placeholder=" " value="' + esc(v) + '"' +
        ' data-baa-field="' + key + '"' + (extra && extra.attrs ? ' ' + extra.attrs : '') +
        ' aria-invalid="' + (!!err) + '"' + (err ? ' aria-describedby="baa-' + key + '-err"' : '') + ' required>' +
      '<label for="baa-' + key + '">' + label + '</label>' +
      (err ? '<span class="baa-err" id="baa-' + key + '-err">' + esc(err) + '</span>' : '') +
    '</div>';
  }

  // Budget brackets in the boutique's currency (falls back to rand).
  function budgetsFor(store) {
    var b = cfg.budgets;
    if (Array.isArray(b)) return b;
    return (store && b[store.country]) || b.ZA || [];
  }

  function renderExtra() {
    var x = state.extra, dErr = state.touched.occasionDate ? occasionDateError() : '';
    var occ = '<option value="">Select an occasion</option>' + cfg.occasions.map(function (o) {
      return '<option value="' + esc(o.value) + '"' + (o.value === x.occasion ? ' selected' : '') + '>' + esc(o.label || o.value) + '</option>';
    }).join('');
    var budgetOpts = '<option value="">Please select</option>' + budgetsFor(state.store).map(function (b) {
      return '<option value="' + esc(b) + '"' + (b === x.budget ? ' selected' : '') + '>' + esc(b) + '</option>';
    }).join('');
    return '' +
      '<div class="baa-extra">' +
        '<p class="baa-label baa-extra__title">Tell us more <span class="baa-optional">(optional)</span></p>' +
        '<div class="baa-q"><label class="baa-q__label" for="baa-occasion">What special occasion are you shopping for?</label>' +
          '<div class="baa-select baa-select--full"><select id="baa-occasion" data-baa-extra="occasion">' + occ + '</select></div></div>' +
        '<div class="baa-q"><p class="baa-q__label" id="baa-occ-date-label">Is there a special date for your occasion?</p>' +
          '<button type="button" class="baa-input baa-input--date' + (x.occasionDate ? ' has-value' : '') + '" id="baa-occasionDate" data-baa-occ-toggle aria-expanded="' + state.occCalOpen + '" aria-labelledby="baa-occ-date-label">' +
            '<span>' + (x.occasionDate ? esc(displayDate(parseDmy(x.occasionDate))) : 'DD/MM/YYYY') + '</span>' +
            '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><rect x="1.5" y="2.5" width="13" height="12" fill="none" stroke="currentColor"/><path d="M1.5 6h13M5 1v3M11 1v3" stroke="currentColor"/></svg>' +
          '</button>' +
          (state.occCalOpen ? renderOccasionCalendar() : '') +
          (x.occasionDate ? '<button type="button" class="baa-link baa-q__clear" data-baa-occ-clear>Clear date</button>' : '') +
        '</div>' +
        '<div class="baa-q"><label class="baa-q__label" for="baa-notes">Please share any additional details to help us best prepare for your appointment:</label>' +
          '<textarea class="baa-q__input baa-q__textarea" id="baa-notes" rows="4" maxlength="1000" data-baa-extra="notes">' + esc(x.notes) + '</textarea></div>' +
        '<div class="baa-q"><label class="baa-q__label" for="baa-budget">Do you have a price range in mind?</label>' +
          '<div class="baa-select baa-select--full"><select id="baa-budget" data-baa-extra="budget">' + budgetOpts + '</select></div></div>' +
      '</div>';
  }

  function renderContactStep() {
    var body = '' +
      '<p class="baa-intro">Please provide your contact details to prepare the details for your ring.</p>' +
      '<p class="baa-note">Contact details are required</p>' +
      '<form class="baa-form" data-baa-contact novalidate>' +
        floatField('firstName', 'First name', 'text', { attrs: 'autocomplete="given-name"' }) +
        floatField('lastName', 'Last name', 'text', { attrs: 'autocomplete="family-name"' }) +
        '<div class="baa-row">' +
          floatField('area', 'Area', 'tel', { cls: 'baa-field--area', attrs: 'inputmode="numeric" autocomplete="tel-country-code" maxlength="5"' }) +
          floatField('mobile', 'Mobile', 'tel', { cls: 'baa-field--grow', attrs: 'inputmode="tel" autocomplete="tel-national"' }) +
        '</div>' +
        floatField('email', 'Email address', 'email', { attrs: 'autocomplete="email"' }) +
        renderExtra() +
        '<input type="text" class="baa-hp" tabindex="-1" autocomplete="off" aria-hidden="true" data-baa-hp>' +
        (state.error ? '<p class="baa-err baa-err--form" role="alert">' + esc(state.error) + '</p>' : '') +
      '</form>';
    var footer = '<button type="button" class="baa-back" data-baa-back>Back</button>' +
      '<button type="button" class="baa-primary" data-baa-send' + (contactValid() && !state.submitting ? '' : ' disabled') + '>' + (state.submitting ? 'Sending…' : 'Send') + '</button>';
    return shell(body, footer);
  }

  function renderDoneStep() {
    return shell('<p class="baa-intro" role="status">Your appointment request has been received. A Browns team member will be in touch to confirm.</p>', '');
  }

  function render(focusSel) {
    var body = root.querySelector('[data-baa-body]');
    var scroll = body ? body.scrollTop : 0;
    var keepScroll = root.dataset.step === state.step;
    root.dataset.step = state.step;
    root.innerHTML = ({ store: renderStoreStep, details: renderDetailsStep, contact: renderContactStep, done: renderDoneStep })[state.step]();
    if (keepScroll) root.querySelector('[data-baa-body]').scrollTop = scroll;
    var f = focusSel && root.querySelector(focusSel);
    (f || root.querySelector('.baa-title')).focus({ preventScroll: keepScroll });
  }

  /* ── Open / close ─────────────────────────────────────── */
  function open(opts) {
    opts = opts || {};
    resetState();
    if (opts.source) state.source = opts.source;
    if (params.get('baa_source')) state.source = params.get('baa_source');
    state.productTitle = opts.productTitle || '';
    state.productUrl = opts.productUrl || '';
    var s = findStore(opts.store);
    if (s) { selectStore(s); state.lockedStore = true; }
    lastTrigger = opts.trigger || document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('baa-open');
    render();
    requestAnimationFrame(function () { root.classList.add('is-visible'); });
  }
  function close() {
    root.classList.remove('is-visible');
    document.documentElement.classList.remove('baa-open');
    setTimeout(function () { root.hidden = true; root.innerHTML = ''; delete root.dataset.step; }, 250);
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }
  function selectStore(s) {
    state.store = s;
    state.country = s.country;
    state.step = 'details';
    state.date = null; state.time = ''; state.calOpen = false;
    if (budgetsFor(s).indexOf(state.extra.budget) < 0) state.extra.budget = '';
    state.contact.area = state.contact.area || cfg.dialCodes[s.country] || '';
    var t = new Date(); t.setDate(t.getDate() + 1);
    state.viewYear = t.getFullYear(); state.viewMonth = t.getMonth();
  }

  /* ── Submit ───────────────────────────────────────────── */
  // Sandbox and production share store ID suffixes; only the org prefix differs. String ops only.
  function envStoreId(id) {
    var p = cfg.zohoIdPrefix;
    return p && id.indexOf(p.from) === 0 ? p.to + id.slice(p.from.length) : id;
  }

  function buildPayload() {
    var F = cfg.fields, c = state.contact, s = state.store;
    var hm = state.time.split(':');
    var start = new Date(state.date.getFullYear(), state.date.getMonth(), state.date.getDate(), parseInt(hm[0], 10), parseInt(hm[1], 10));
    var end = new Date(start.getTime() + durationFor(state.type) * 60000);
    var type = cfg.appointmentTypes.filter(function (t) { return t.id === state.type; })[0];
    var mobile = '+' + c.area.replace(/\D/g, '') + c.mobile.replace(/\D/g, '').replace(/^0/, '');

    var values = {
      appointmentDate: zohoDate(start),
      appointmentTime: state.time,
      start: zohoDate(start), startHour: hour12(start), startMinute: pad(start.getMinutes()), startAmpm: ampm(start),
      end: zohoDate(end), endHour: hour12(end), endMinute: pad(end.getMinutes()), endAmpm: ampm(end),
      source: state.source,
      topic: type.topic,
      opportunityType: type.opportunityType,
      // Same "contactId|storeId" pattern the candle Deluge function splits to link Client + Store.
      saleMessage: contactId + '|' + envStoreId(s.zohoId),
      firstName: c.firstName.trim(),
      lastName: c.lastName.trim(),
      email: c.email.trim(),
      mobile: mobile,
      productLink: state.productUrl ? state.productTitle + ' – ' + state.productUrl : '',
      calendarEventRequired: 'on',
      occasion: state.extra.occasion,
      // No occasion-date field in Zoho, so it goes into the Occasion Details text field.
      occasionDetails: state.extra.occasionDate.trim() ? 'Occasion date: ' + state.extra.occasionDate.trim() : '',
      budget: state.extra.budget.trim(),
      notes: state.extra.notes.trim()
    };

    var entries = [
      ['xnQsjsdp', cfg.webform.xnQsjsdp], ['zc_gad', ''], ['xmIwtLD', cfg.webform.xmIwtLD],
      ['actionType', cfg.webform.actionType], ['returnURL', 'null'], [cfg.webform.honeypot, '']
    ];
    Object.keys(cfg.static).forEach(function (k) { entries.push([k, cfg.static[k]]); });
    var unmapped = [];
    Object.keys(values).forEach(function (k) {
      var base = k.replace(/(Hour|Minute|Ampm)$/, '');
      var name = F[base];
      if (base !== k) { if (name) entries.push([name + k.slice(base.length).toLowerCase(), values[k]]); return; }
      if (name) entries.push([name, values[k]]); else unmapped.push([k, values[k]]);
    });
    return { entries: entries, unmapped: unmapped, values: values };
  }

  function hiddenForm(entries) {
    var form = document.createElement('form');
    form.id = 'webform' + cfg.webform.formId;
    form.action = cfg.webform.action; form.method = 'POST'; form.acceptCharset = 'UTF-8';
    form.hidden = true;
    entries.forEach(function (e) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = e[0]; i.value = e[1]; form.appendChild(i);
    });
    document.body.appendChild(form);
    return form;
  }

  function track(event) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: event, baa_source: state.source, baa_store: state.store && state.store.code, baa_type: state.type });
  }

  function submit() {
    if (!contactValid() || state.submitting) return;
    var hp = root.querySelector('[data-baa-hp]');
    if (hp && hp.value) { state.step = 'done'; render(); return; }
    if (availabilityOn() && !state.slotChecked) {
      // Last-second check that nobody booked this slot while the client filled in the form.
      state.submitting = true; render();
      fetchBusy(state.store, state.date, true).then(function () {
        state.submitting = false;
        if (freeSlotValues(state.store, state.date, state.type).indexOf(state.time) < 0) {
          state.time = ''; state.step = 'details';
          state.slotError = 'Sorry, that time has just been booked. Please choose another time.';
          return render('[data-baa-time]');
        }
        state.slotChecked = true;
        submit();
      });
      return;
    }
    state.slotChecked = false;
    var p = buildPayload();
    api.lastPayload = p;
    state.submitting = true; state.error = ''; render();

    if (dryRun) {
      console.info('[Book an Appointment] DRY RUN – webform keys not set, nothing sent.');
      console.table(p.entries.map(function (e) { return { field: e[0], value: e[1] }; }));
      if (p.unmapped.length) console.warn('[Book an Appointment] values without a Zoho field yet:', p.unmapped);
      setTimeout(function () { state.submitting = false; state.step = 'done'; track('book_appointment_submit'); render(); }, 400);
      return;
    }

    var form = hiddenForm(p.entries);
    if (typeof window._wfa_track !== 'undefined' && window._wfa_track.wfa_submit) {
      try { window._wfa_track.wfa_submit({ target: form }); } catch (e) {}
    }
    fetch(cfg.webform.action, { method: 'POST', body: new FormData(form), cache: 'no-cache' })
      .then(function (r) {
        var ct = r.headers.get('Content-Type') || '';
        return ct.indexOf('application/json') > -1 ? r.json() : r.text();
      })
      .then(function (data) {
        if (typeof data === 'object' && (data.actionsubmit === 'error_msg' || data.actionsubmit === 'captcha_error')) throw new Error(data.message);
        state.submitting = false; state.step = 'done'; track('book_appointment_submit'); render();
      })
      .catch(function (err) {
        state.submitting = false;
        state.error = (err && err.message) || 'Something went wrong. Please try again.';
        render();
      })
      .then(function () { form.remove(); });
  }

  /* ── Events ───────────────────────────────────────────── */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, [data-baa-close]');
    if (!t) {
      if (state.calOpen && !e.target.closest('[data-baa-cal]')) { state.calOpen = false; render(); }
      if (state.occCalOpen && !e.target.closest('[data-baa-occ-cal]')) { state.occCalOpen = false; render(); }
      return;
    }
    var d = t.dataset;
    if ('baaOccToggle' in d) {
      state.occCalOpen = !state.occCalOpen;
      if (state.occCalOpen) {
        var base = parseDmy(state.extra.occasionDate) || new Date();
        state.occViewYear = base.getFullYear(); state.occViewMonth = base.getMonth();
      }
      return render(state.occCalOpen ? '.baa-cal__day[data-baa-occ-day]' : '#baa-occasionDate');
    }
    if (d.baaOccNav) {
      state.occViewMonth += parseInt(d.baaOccNav, 10);
      if (state.occViewMonth < 0) { state.occViewMonth = 11; state.occViewYear--; }
      if (state.occViewMonth > 11) { state.occViewMonth = 0; state.occViewYear++; }
      return render('[data-baa-occ-nav="' + d.baaOccNav + '"]');
    }
    if (d.baaOccDay) {
      var q = d.baaOccDay.split('-');
      state.extra.occasionDate = pad(+q[2]) + '/' + pad(+q[1]) + '/' + q[0];
      state.occCalOpen = false;
      return render('#baa-occasionDate');
    }
    if ('baaOccClear' in d) { state.extra.occasionDate = ''; state.occCalOpen = false; return render('#baa-occasionDate'); }
    if ('baaClose' in d) return close();
    if (d.baaSelect) { selectStore(findStore(d.baaSelect)); return render(); }
    if ('baaChange' in d) { state.step = 'store'; state.lockedStore = false; return render(); }
    if (d.baaType) {
      state.type = d.baaType;
      if (state.date && freeSlotValues(state.store, state.date, state.type).indexOf(state.time) < 0) state.time = '';
      state.slotError = '';
      return render('[data-baa-type="' + d.baaType + '"]');
    }
    if ('baaDateToggle' in d) { state.calOpen = !state.calOpen; return render(state.calOpen ? '.baa-cal__day:not([disabled])' : '[data-baa-date-toggle]'); }
    if (d.baaCalNav) {
      state.viewMonth += parseInt(d.baaCalNav, 10);
      if (state.viewMonth < 0) { state.viewMonth = 11; state.viewYear--; }
      if (state.viewMonth > 11) { state.viewMonth = 0; state.viewYear++; }
      return render('[data-baa-cal-nav="' + d.baaCalNav + '"]');
    }
    if (d.baaDay) {
      var p = d.baaDay.split('-');
      state.date = new Date(+p[0], +p[1] - 1, +p[2]);
      state.calOpen = false;
      if (freeSlotValues(state.store, state.date, state.type).indexOf(state.time) < 0) state.time = '';
      state.slotError = '';
      loadBusy(false);
      return render('[data-baa-time]');
    }
    if ('baaBack' in d) { state.step = state.step === 'contact' ? 'details' : 'store'; state.error = ''; state.occCalOpen = false; return render(); }
    if ('baaNext' in d && detailsValid()) { state.step = 'contact'; return render('#baa-firstName'); }
    if ('baaSend' in d) return submit();
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if ('baaCountry' in t.dataset) { state.country = t.value; state.region = 'all'; return render('[data-baa-country]'); }
    if ('baaRegion' in t.dataset) { state.region = t.value; return render('[data-baa-region]'); }
    if ('baaTime' in t.dataset) { state.time = t.value; return render('[data-baa-time]'); }
    if (t.dataset.baaExtra === 'occasion' || t.dataset.baaExtra === 'budget') state.extra[t.dataset.baaExtra] = t.value;
  });

  // Contact fields update state without a full re-render so typing isn't interrupted.
  root.addEventListener('input', function (e) {
    var xk = e.target.dataset.baaExtra;
    if (xk) {
      if (xk === 'occasionDate') {
        // Auto-insert the slashes: 14022027 -> 14/02/2027
        var dg = e.target.value.replace(/\D/g, '').slice(0, 8);
        var f = dg.length > 4 ? dg.slice(0, 2) + '/' + dg.slice(2, 4) + '/' + dg.slice(4) : dg.length > 2 ? dg.slice(0, 2) + '/' + dg.slice(2) : dg;
        if (f !== e.target.value) e.target.value = f;
      }
      state.extra[xk] = e.target.value;
      if (xk === 'occasionDate' && state.touched.occasionDate) syncOccasionDateError();
      var sb = root.querySelector('[data-baa-send]');
      if (sb) sb.disabled = !contactValid();
      return;
    }
    var k = e.target.dataset.baaField;
    if (!k) return;
    state.contact[k] = e.target.value;
    var send = root.querySelector('[data-baa-send]');
    if (send) send.disabled = !contactValid();
    if (state.touched[k]) syncFieldError(k);
  });
  root.addEventListener('focusout', function (e) {
    if (e.target.dataset && e.target.dataset.baaExtra === 'occasionDate' && state.extra.occasionDate) {
      state.touched.occasionDate = true;
      syncOccasionDateError();
      return;
    }
    var k = e.target.dataset && e.target.dataset.baaField;
    if (!k || !state.contact[k]) return;
    state.touched[k] = true;
    syncFieldError(k);
  });
  function syncFieldError(k) {
    var wrap = root.querySelector('#baa-' + k).parentNode;
    var err = fieldError(k);
    var el = wrap.querySelector('.baa-err');
    wrap.classList.toggle('has-error', !!err);
    wrap.querySelector('input').setAttribute('aria-invalid', !!err);
    if (err && !el) { el = document.createElement('span'); el.className = 'baa-err'; el.id = 'baa-' + k + '-err'; wrap.appendChild(el); wrap.querySelector('input').setAttribute('aria-describedby', el.id); }
    if (el) { if (err) el.textContent = err; else { el.remove(); wrap.querySelector('input').removeAttribute('aria-describedby'); } }
  }
  function syncOccasionDateError() {
    var input = root.querySelector('#baa-occasionDate');
    if (!input) return;
    var wrap = input.parentNode, err = occasionDateError(), el = wrap.querySelector('.baa-err');
    wrap.classList.toggle('has-error', !!err);
    input.setAttribute('aria-invalid', !!err);
    if (err && !el) { el = document.createElement('span'); el.className = 'baa-err'; el.id = 'baa-occasionDate-err'; wrap.appendChild(el); input.setAttribute('aria-describedby', el.id); }
    if (el) { if (err) el.textContent = err; else { el.remove(); input.removeAttribute('aria-describedby'); } }
    var sb = root.querySelector('[data-baa-send]');
    if (sb) sb.disabled = !contactValid();
  }
  root.addEventListener('submit', function (e) { e.preventDefault(); submit(); });

  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') {
      if (state.calOpen) { state.calOpen = false; render('[data-baa-date-toggle]'); }
      else if (state.occCalOpen) { state.occCalOpen = false; render('#baa-occasionDate'); }
      else close();
    }
    if (e.key === 'Tab') {
      var f = root.querySelectorAll('.baa-drawer button:not([disabled]), .baa-drawer input:not([tabindex="-1"]), .baa-drawer select:not([disabled]), .baa-drawer textarea');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // CTAs anywhere on the site
  document.addEventListener('click', function (e) {
    // composedPath() also finds CTAs rendered inside a component's shadow DOM (e.g. the sticky header).
    var path = e.composedPath ? e.composedPath() : [e.target];
    var t = null;
    for (var i = 0; i < path.length && !t; i++) {
      var el = path[i];
      if (el && el.nodeType === 1 && el.matches('[data-book-appointment], a[href$="#book-an-appointment"]')) t = el;
    }
    if (!t) return;
    e.preventDefault();
    open({
      source: t.dataset.baaSource,
      store: t.dataset.baaStore,
      productTitle: t.dataset.baaProductTitle,
      productUrl: t.dataset.baaProductUrl,
      trigger: t
    });
  });

  // Store-specific CTAs (e.g. the boutiques page) for a boutique that isn't bookable are hidden,
  // so customers never land on the boutique list from a "Book at <store>" button.
  function hideUnbookableCtas() {
    document.querySelectorAll('[data-book-appointment][data-baa-store]').forEach(function (el) {
      if (!findStore(el.getAttribute('data-baa-store'))) el.hidden = true;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideUnbookableCtas);
  else hideUnbookableCtas();

  // The header nav CTA is rendered inside the sticky header's shadow root, where
  // book-appointment.css can't reach, so the same nav rules are adopted into that root.
  // Mirrors .baa-cta--nav in book-appointment.css – keep both in step.
  var NAV_SHADOW_CSS =
    '.baa-cta--nav{white-space:nowrap;text-align:right}' +
    '.baa-cta--nav:hover{text-decoration:underline;text-underline-offset:3px}' +
    '@media (max-width:767px){.baa-cta--nav{white-space:normal;line-height:1.25;order:1}}';
  var navSheet = null;
  function styleShadowCtas() {
    if (!('adoptedStyleSheets' in Document.prototype)) return;
    document.querySelectorAll('sticky-header, header *, [class*="header"]').forEach(function (host) {
      var root = host.shadowRoot;
      if (!root || !root.querySelector('.baa-cta--nav')) return;
      if (!navSheet) { navSheet = new CSSStyleSheet(); navSheet.replaceSync(NAV_SHADOW_CSS); }
      if (root.adoptedStyleSheets.indexOf(navSheet) === -1) root.adoptedStyleSheets = root.adoptedStyleSheets.concat(navSheet);
    });
  }
  // The header component renders after it upgrades, so check again once things settle.
  styleShadowCtas();
  document.addEventListener('DOMContentLoaded', styleShadowCtas);
  window.addEventListener('load', styleShadowCtas);
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('sticky-header').then(function () { setTimeout(styleShadowCtas, 0); });

  var api = window.BrownsBookAppointment = { open: open, close: close, stores: stores, findStore: findStore, dryRun: dryRun, lastPayload: null };

  // Deep links: /pages/book-an-appointment, #book-an-appointment, ?book_appointment=1&store=RSE
  if (/\/pages\/book-an-appointment\/?$/.test(location.pathname) || location.hash === '#book-an-appointment' || params.has('book_appointment')) {
    open({ source: params.get('baa_source') || cfg.defaultSource, store: params.get('store') });
  }
})();
